import { ReactComponent as PointIcon } from '@epam/assets/icons/common/action-map_pin-18.svg'
import { ReactComponent as TargetIcon } from '@epam/assets/icons/common/action-target-18.svg'
import { DropdownBodyProps, IDropdownToggler } from '@epam/uui-core'
import { ReactComponent as LayerIcon } from '../../../../icons/select-layer.svg'
import { Button, Tooltip } from '@epam/loveship'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useActions } from '../../../../hooks/redux/actions'
import css from './MapMenu.module.scss'
import { Dropdown, DropdownMenuBody, DropdownMenuButton } from '@epam/uui'
import { MapLayersEnum } from '../../../../constants/enums'

export const MapMenu = () => {
  const { showCreateNewPoint, showCreateNewEvent } = useSideBarControlls()
  const { currentTabSelected, mapLayer } = useAppSelector((state) => state.app)
  const {
    setShouldLocateUser,
    setMapLayer,
    setSelectedEventId,
    setSelectedPointId,
  } = useActions()
  const handleAddClick = () => {
    setSelectedEventId(null)
    setSelectedPointId(null)
    if (currentTabSelected === 'locations') {
      showCreateNewPoint()
    } else {
      showCreateNewEvent()
    }
  }

  const renderThirdDropdownBody = (props: DropdownBodyProps) => (
    <DropdownMenuBody
      {...props}
      rawProps={{ style: { padding: 0, width: '190px' } }}
    >
      {Object.values(MapLayersEnum).map((layer) => (
        <DropdownMenuButton
          isSelected={mapLayer === layer}
          key={layer}
          caption={layer}
          onClick={() => {
            setMapLayer(layer)
          }}
        />
      ))}
    </DropdownMenuBody>
  )

  return (
    <div className={css.mapMenuWrapper}>
      <Tooltip
        content={
          currentTabSelected === 'locations' ? 'Add New Place' : 'Add New Event'
        }
        placement="left"
        color="white"
      >
        <Button
          cx={css.mapMenuItem}
          fill="white"
          color="sky"
          onClick={handleAddClick}
          icon={PointIcon}
        />
      </Tooltip>

      <Tooltip content="Find my location" placement="left" color="white">
        <Button
          cx={css.mapMenuItem}
          fill="white"
          color="sky"
          onClick={() => setShouldLocateUser(true)}
          icon={TargetIcon}
        />
      </Tooltip>
      <Dropdown
        renderBody={renderThirdDropdownBody}
        renderTarget={(props: IDropdownToggler) => (
          <Tooltip content="Layer" placement="left" color="white">
            <div className={css.filterButtonWrapper}>
              <Button
                cx={css.mapMenuItem}
                fill="white"
                color="sky"
                icon={LayerIcon}
                {...props}
                isDropdown={false}
              />
            </div>
          </Tooltip>
        )}
        placement="bottom-end"
      />
    </div>
  )
}
